// extracted by mini-css-extract-plugin
export default {"image":"SelectStepType_image__gFCH7","name":"SelectStepType_name__qPoy1"};